import { UserPreferences } from '@repo/user-types'
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

export const getUserPreferences = async ({
  api,
  config,
}: {
  api: AxiosInstance
  params?: void
  config?: Pick<AxiosRequestConfig, 'signal'>
}): Promise<AxiosResponse<UserPreferences>> => {
  return api.get<UserPreferences>('/user/preferences', config)
}

export const patchUserPreferences = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: UserPreferences
}): Promise<AxiosResponse<void>> => {
  return api.patch<void>('/user/preferences', params)
}
